/**
 * 用户中心路由配置
 */

import type { RouteRecordRaw } from 'vue-router';

// 用户中心组件懒加载 - 优化代码分割
const UserCenter = () => import(/* webpackChunkName: "user-center" */ '@/views/user/UserCenter.vue');
const Overview = () => import(/* webpackChunkName: "user-overview" */ '@/views/user/Overview.vue');
const Membership = () => import(/* webpackChunkName: "user-membership" */ '@/views/user/Membership.vue');
const OrderList = () => import(/* webpackChunkName: "user-orders" */ '@/views/user/OrderList.vue');
const PaymentLog = () => import(/* webpackChunkName: "user-payments" */ '@/views/user/PaymentLog.vue');
const Profile = () => import(/* webpackChunkName: "user-profile" */ '@/views/user/Profile.vue');
const Favorites = () => import(/* webpackChunkName: "user-favorites" */ '@/views/user/Favorites.vue');
const Entitlement = () => import(/* webpackChunkName: "user-entitlement" */ '@/views/user/Entitlement.vue');
const Achievements = () => import(/* webpackChunkName: "user-achievements" */ '@/views/user/Achievements.vue');
const NotificationCenter = () => import(/* webpackChunkName: "user-notifications" */ '@/views/user/NotificationCenter.vue');

// 用户中心路由
export const userRoutes: RouteRecordRaw[] = [
  {
    path: '/user',
    component: UserCenter,
    meta: {
      title: '用户中心',
      icon: 'User',
      requiresAuth: true,
      showIcp: false  // 用户中心不显示备案号
    },
    children: [
      {
        path: '',
        redirect: '/user/overview'
      },
      {
        path: 'overview',
        name: 'Overview',
        component: Overview,
        meta: {
          title: '账户总览',
          icon: 'DataBoard'
        }
      },
      {
        path: 'notifications',
        name: 'NotificationCenter',
        component: NotificationCenter,
        meta: {
          title: '通知中心',
          icon: 'Bell'
        }
      },
      {
        path: 'membership',
        name: 'Membership',
        component: Membership,
        meta: {
          title: '开通会员',
          icon: 'Crown'
        }
      },
      {
        path: 'order-list',
        name: 'OrderList',
        component: OrderList,
        meta: {
          title: '订单列表',
          icon: 'Tickets'
        }
      },
      {
        path: 'payment-log',
        name: 'PaymentLog',
        component: PaymentLog,
        meta: {
          title: '支付记录',
          icon: 'CreditCard'
        }
      },
      {
        path: 'profile',
        name: 'Profile',
        component: Profile,
        meta: {
          title: '账户设置',
          icon: 'UserFilled'
        }
      },
      {
        path: 'favorites',
        name: 'Favorites',
        component: Favorites,
        meta: {
          title: '我的收藏',
          icon: 'Star'
        }
      },
      {
        path: 'entitlement',
        name: 'Entitlement',
        component: Entitlement,
        meta: {
          title: '权益中心',
          icon: 'Coin'
        }
      },
      {
        path: 'achievements',
        name: 'Achievements',
        component: Achievements,
        meta: {
          title: '我的成就',
          icon: 'Trophy'
        }
      }
    ]
  }
];
